import { FormShowTemplate } from 'framework/form';
import CyclesSettings from './CycleSettings/CyclesSettings';
import CycleApproveAnnotation from './CycleApprove/CycleApproveAnnotation';
import { useProjectId } from 'domain/shared/project';
import useProjectCycleService from './useProjectCycleService';
import { useCallback } from 'react';
import { CYCLE_FREQUENCY, CycleSettingsStatus, useProjectDataContext } from 'domain/shared/newProject';

const CyclesLayout = () => {
  const id = useProjectId();
  const { data } = useProjectDataContext();
  const { updateCycleSettings, getCycleSettingsValidationSchema } = useProjectCycleService();

  const getData = useCallback(async () => {
    return Promise.resolve(data);
  }, [data]);

  return (
    <FormShowTemplate
      isInitialsLoadingPosition
      submitFormFunc={async values => {
        const cycleActivitySettings = values.settings.cycleActivitySettings;

        const updatedCycleFrequency = {
          cycleFrequency: cycleActivitySettings.cycleFrequency ?? CYCLE_FREQUENCY.WEEKLY,
          cycleChangeReason: null,
          cycleSettingsStatus: cycleActivitySettings.cycleSettingsStatus ?? CycleSettingsStatus.APPROVED,
        };

        if (cycleActivitySettings.changeCycleFrequency) {
          if (cycleActivitySettings.cycleFrequency === CYCLE_FREQUENCY.BIWEEKLY) {
            updatedCycleFrequency.cycleFrequency = CYCLE_FREQUENCY.WEEKLY;
            updatedCycleFrequency.cycleSettingsStatus = CycleSettingsStatus.APPROVED;
          } else if (cycleActivitySettings.cycleFrequency === CYCLE_FREQUENCY.WEEKLY) {
            updatedCycleFrequency.cycleFrequency = CYCLE_FREQUENCY.BIWEEKLY;
            updatedCycleFrequency.cycleSettingsStatus = CycleSettingsStatus.IN_APPROVAL;
            updatedCycleFrequency.cycleChangeReason = cycleActivitySettings.changeCycleFrequencyReason;
          }
        }

        const updatedSettings = await updateCycleSettings(id, {
          projectId: id,
          cycleStartDay: cycleActivitySettings.cycleStartDay,
          cycleEndDay: cycleActivitySettings.cycleEndDay,
          planningDay: cycleActivitySettings.planningDay,
          demoDay: cycleActivitySettings.demoDay,
          ...updatedCycleFrequency,
        });

        return { settings: updatedSettings };
      }}
      afterSubmit={{
        message: 'You are awesome! Cycle settings has been updated successfully.',
      }}
      getDataFunc={getData}
      getValidationSchemaFunc={getCycleSettingsValidationSchema}
    >
      <CycleApproveAnnotation projectId={id} />
      <CyclesSettings />
    </FormShowTemplate>
  );
};
export default CyclesLayout;
